import { Mixpanel, MixpanelEvents } from "../../services/Mixpanel";
import constants from "../../constants";

const { MIXPANEL_HEADER_CONFIG } = constants;

/**
 * Get page name from pathname
 * @param {string} pathname - Current page pathname
 * @returns {string} - Formatted page name
 */
const getPageName = pathname => {
  if (!pathname || pathname === "/") return "Homepage";

  // Remove leading/trailing slashes and convert to title case
  const pageName = pathname
    .replace(/^\/|\/$/g, "")
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return pageName || "Homepage";
};

/**
 * Track navigation link clicks
 * @param {string} linkLabel - Label of the navigation link
 * @param {string} location - Location where click happened (Header/Mobile Menu)
 * @param {string} pathname - Current page pathname
 */
export const trackNavLinkClick = (linkLabel, location, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.nav_link_clicked, {
    page_name: pageName,
    asset: MIXPANEL_HEADER_CONFIG.asset,
    asset_name: MIXPANEL_HEADER_CONFIG.assetName,
    cta_text: linkLabel,
    cta_location: location,
  });
};

/**
 * Track CTA button clicks (Contact US, Enroll now)
 * @param {string} ctaLabel - Label of the CTA button
 * @param {string} location - Location where click happened (Header/Mobile Menu)
 * @param {string} pathname - Current page pathname
 */
export const trackCTAClick = (ctaLabel, location, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.contact_button_clicked, {
    page_name: pageName,
    asset: MIXPANEL_HEADER_CONFIG.asset,
    asset_name: MIXPANEL_HEADER_CONFIG.assetName,
    cta_text: ctaLabel,
    cta_location: location,
  });
};

/**
 * Track logo clicks
 * @param {string} location - Location where click happened (Header/Mobile Menu)
 * @param {string} pathname - Current page pathname
 */
export const trackLogoClick = (location, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.logo_clicked, {
    page_name: pageName,
    asset: MIXPANEL_HEADER_CONFIG.asset,
    asset_name: MIXPANEL_HEADER_CONFIG.assetName,
    cta_text: "Twin Health Logo",
    cta_location: location,
  });
};

/**
 * Track mobile menu open/close
 * @param {boolean} isOpen - Whether menu is being opened or closed
 * @param {string} pathname - Current page pathname
 */
export const trackMobileMenuToggle = (isOpen, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.nav_link_clicked, {
    page_name: pageName,
    asset: MIXPANEL_HEADER_CONFIG.asset,
    asset_name: MIXPANEL_HEADER_CONFIG.assetName,
    cta_text: isOpen ? "Open Mobile Menu" : "Close Mobile Menu",
    cta_location: MIXPANEL_HEADER_CONFIG.locations.mobileMenu,
  });
};
